import { Text } from "@fluentui/react-components";
import { useStyles } from "../../../../../styles/styleClasses";
import { mergeClasses } from "@fluentui/react-components";
import {
  LanguageStrings,
  useLocalization,
} from "../../../../../contexts/LocalizationContext";

function RequestDate(props: { createdDate: string }) {
  const styles = useStyles();
  const localized = useLocalization() as LanguageStrings;

  return (
    <div className={styles.overflowHidden}>
      <div className={styles.pbXs}>
        <Text
          block
          truncate
          className={mergeClasses(
            styles.textNeutralForeground3,
            styles.textOverflow,
            styles.overflowHidden
          )}
        >
          {localized.RequestDate}
        </Text>
      </div>
      <Text
        block
        truncate
        weight="semibold"
        className={mergeClasses(
          styles.textNeutralForeground1,
          styles.textOverflow,
          styles.overflowHidden
        )}
      >
        {props.createdDate}
      </Text>
    </div>
  );
}

export default RequestDate;
